import { useEffect } from "react";
import { primeraLetraMayusculaOracion } from "../../utils/utils";

export const FiltroSelect = ({ nombre, opciones, setOpcionesSeleccionadas, indice, selectedDefault }) => {
    const classNameSelect = "h-[34px] dark:text-white rounded w-full bg-zinc-800  dark:bg-gray-800 focus:outline-none focus:ring-1 focus:ring-blue-500";
    const obtenerValoresFiltro = (valor) => {
        setOpcionesSeleccionadas(prevOpciones => {    
            const nuevasOpciones = [ ...prevOpciones ];
            nuevasOpciones[indice] = valor;
            return nuevasOpciones
        })
    }
    useEffect(() => {
        setOpcionesSeleccionadas(prevOpciones => {
            const nuevasOpciones = [ ...prevOpciones ];
            nuevasOpciones[indice] = selectedDefault  == '' ? '' : selectedDefault;
            // nuevasOpciones[indice] = opciones.length > 1 ? '' : opciones[0];
            return nuevasOpciones
        })
    },[])
    return(
        <select
            className={`${classNameSelect}`}
            onChange={(e)=> obtenerValoresFiltro(e.target.value)}
            defaultValue={selectedDefault}
        >
            {
                <option value={''}>-- Todos --</option>
            }
            {
                opciones.length > 0 && (
                    opciones.map((d,i) => {
                        return(
                            <option key={`${d}-${i}`} value={d}>{primeraLetraMayusculaOracion(d)}</option>
                        )
                    })
                )
            }
        </select>
    )

}